import { HttpError } from './http-error';

export abstract class HttpRequestErrorHandler {
  public abstract onRemoteServiceUnavailable(error: HttpError): void;

  public abstract onError(error: HttpError): HttpError;
}
